// Globals
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Modal, ModalSize } from '@/components';
import ApproveFaqForm from '../ApproveFaqForm/ApproveFaqForm';

// Models
import { ISuggestedFaqSourceChannel, TApproveSuggestedFaqTarget } from '@/models/suggestedFaq.model';

// Helpers
import { getApproveFaqFormValues } from '../../helpers';

type TApproveFaqModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onApprove: (data: TApproveSuggestedFaqTarget) => void;
  isLoading?: boolean;
  sourceChannels?: ISuggestedFaqSourceChannel[];
};

const ApproveFaqModal: FC<TApproveFaqModalProps> = ({ isOpen, onClose, onApprove, isLoading, sourceChannels }) => {
  const { t } = useTranslation();
  const initialValues = useMemo(() => getApproveFaqFormValues(sourceChannels), [sourceChannels]);

  return (
    <Modal
      destroyOnClose
      title={t('approve_suggested_faq_title')}
      onCancel={onClose}
      visible={isOpen}
      size={ModalSize.MEDIUM}
    >
      <ApproveFaqForm initialValues={initialValues} isLoading={isLoading} onSubmit={onApprove} onReset={onClose} />
    </Modal>
  );
};

export default ApproveFaqModal;
